// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-summary-card {
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  padding: 20px;
  background-color: #fff;
}
.order-summary-card .card-title {
  font-size: 1.125rem;
  font-weight: bold;
}
.order-summary-card .order-summary-item {
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.order-summary-card .order-summary-item:last-child {
  border-bottom: none;
}
.order-summary-card .item-description .item-title {
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
}
.order-summary-card .item-description .item-discount {
  display: flex;
  align-items: center;
  gap: 5px;
}
.order-summary-card .item-description .item-discount .original-price {
  font-size: 0.8rem;
  color: #888;
}
.order-summary-card .item-description .item-discount .discount-text {
  font-size: 0.8rem;
  color: #ff5a5f;
  font-weight: 500;
}
.order-summary-card .price {
  color: #564ffd;
  font-weight: bold;
  font-size: 1rem;
}
.order-summary-card hr {
  margin: 1rem 0;
}
.order-summary-card .total-section .total-label {
  font-size: 1rem;
  font-weight: 600;
  color: #555;
}
.order-summary-card .total-section .total-amount {
  font-size: 1.125rem;
  font-weight: bold;
  color: #564ffd;
}

.complete-payment-button {
  background-color: #564ffd !important;
  border: none;
  padding: 12px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 8px;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/PaymentForm/OrderSummary.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;EACA,iBAAA;AACJ;AAEE;EACE,oBAAA;EACA,gCAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAKI;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAJN;AAMM;EACE,iBAAA;EACA,WAAA;AAJR;AAOM;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AALR;AAUE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AARJ;AAWE;EACE,cAAA;AATJ;AAaI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAXN;AAcI;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;AAZN;;AAiBA;EACE,oCAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAdF","sourcesContent":[".order-summary-card {\n  border: 1px solid #e1e1e1;\n  border-radius: 8px;\n  padding: 20px;\n  background-color: #fff;\n\n  .card-title {\n    font-size: 1.125rem;\n    font-weight: bold;\n  }\n\n  .order-summary-item {\n    padding-bottom: 10px;\n    border-bottom: 1px solid #f0f0f0;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .item-description {\n    .item-title {\n      font-size: 0.9rem;\n      font-weight: 500;\n      color: #333;\n    }\n\n    .item-discount {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n\n      .original-price {\n        font-size: 0.8rem;\n        color: #888;\n      }\n\n      .discount-text {\n        font-size: 0.8rem;\n        color: #ff5a5f;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .price {\n    color: #564ffd;\n    font-weight: bold;\n    font-size: 1rem;\n  }\n\n  hr {\n    margin: 1rem 0;\n  }\n\n  .total-section {\n    .total-label {\n      font-size: 1rem;\n      font-weight: 600;\n      color: #555;\n    }\n\n    .total-amount {\n      font-size: 1.125rem;\n      font-weight: bold;\n      color: #564ffd;\n    }\n  }\n}\n\n.complete-payment-button {\n  background-color: #564ffd !important;\n  border: none;\n  padding: 12px;\n  font-size: 1rem;\n  font-weight: bold;\n  border-radius: 8px;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
